
<div class="controls">
    <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
    </mat-form-field>
</div>
  
<div class="mat-elevation-z8">
    <table mat-table [dataSource]="data" matSort>

        <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
            <td mat-cell *matCellDef="let row"> {{row.AccountStatus}} </td>
        </ng-container>

        <ng-container matColumnDef="Email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let row"> {{row.Email}} </td>
        </ng-container>

        <ng-container matColumnDef="EmailVerified">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Verified </th>
            <td mat-cell *matCellDef="let row"> {{row.Emailverified}} </td>
        </ng-container>

        <ng-container matColumnDef="LastModifiedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Modified </th>
            <td mat-cell *matCellDef="let row"> {{row.LastModifiedDate | date: "MM/dd/yyyy"}} </td>
        </ng-container>

        <ng-container matColumnDef="CreatedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Created </th>
            <td mat-cell *matCellDef="let row"> {{row.CreatedDate | date: "MM/dd/yyyy"}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="element-row"
        (click)="openDialog(row.Username)"
        ></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
